const TranslationList = {
  install(Vue, options = {}) {
    Vue.prototype.$tlist = function (key) {
      let counter = 1;
      const items = [];
      let currentItem = null;
      let currentKey = null;

      do {
        currentKey = `${key}_${counter}`;
        currentItem = this.$t(currentKey);

        if (currentItem == currentKey) {
          currentItem = null;
        }

        if (currentItem) {
          items.push(currentItem);
        }

        counter++;
      } while (currentItem);

      return items;
    };
  },
};

export default TranslationList;
